import { pipe, toPairs, map, head, last, join, isEmpty } from 'ramda';
export var toCustomParamStr = pipe(toPairs, map(function (pair) {
  return [head(pair), encodeURIComponent(last(pair))];
}), map(join('=')), join('&'));
export var toBrokerURLString = function toBrokerURLString(brokerCode) {
  if (brokerCode) {
    return '&brokerCode='.concat(brokerCode);
  }

  return '';
};
export var toCustomURLString = function toCustomURLString(customParamStr) {
  if (!isEmpty(customParamStr)) {
    return '&'.concat(customParamStr);
  }

  return '';
};
export var trackEvent = function trackEvent(eventType) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventType
  });
};